import appApi from '../../../../../api/app-api';
import { toast } from 'react-toastify';
import globalSettingsStores from '../../../../../stores/settings-stores';

export const editListNameOperation = async (
  listId: number,
  listName: string,
  setLoading: (loading: boolean) => any,
) => {
  try {
    if (listName.length < 3) {
      toast.warn('על שם הרשימה להיות בין 3 ל- 60 תווים');
      return;
    }

    setLoading(true);
    await appApi.editClassList(listId, listName);
    globalSettingsStores.fetchSetting();
    setLoading(false);
  } catch (e) {
    setLoading(false);
    console.error(
      `editListNameOperation is failed with the listId: ${listId}, listName: ${listName} and the error: ${e}`,
    );
  }
};
